import type { Driver } from '@cobliteam/api-lib/src/dashboard/driver/Types';

import { Checkbox } from '@cobliteam/base-components/src/SelectionControls/Checkbox';

interface DriverItemProps {
  checked: boolean;
  data: Driver;
  onChange: () => void;
}

const DriverItem = ({ checked, onChange, data }: DriverItemProps) => {
  const { id, name } = data;

  const personName = name
    .split(' ')
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1, 35).toLowerCase()
    )
    .join(' ');

  return (
    <div className='ml-5'>
      <Checkbox
        key={`${id}-driver-item`}
        checked={checked}
        onChange={onChange}
        label={personName}
      />
    </div>
  );
};
export default DriverItem;
